import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { Order } from '../models/order.model';
import { InvoiceService } from '../services/invoice.service';
import { FeeBasisAdjustment } from '../models/fee-basis-adjustment.model';

@Pipe({
    name: 'total',
    standalone: false
})
export class TotalPipe implements PipeTransform {
  constructor(
    private invoiceService: InvoiceService,
  ) {

  }

  transform(value: Order[], key: 'pipelineProjectSumExVat' | 'salesRealizators' | 'executors' | 'pipelineWeightedProjectSum' | 'projectSumExVat' | 'distribution', consultant?: string, adjustments?: FeeBasisAdjustment[]): number {
    if (key == "salesRealizators" || key == "executors") {
      if (consultant) {
        let consultantAdjustment = 0;
        if (key == "salesRealizators") {
          consultantAdjustment = adjustments.filter(_ => _.salesRealizator && _.consultantId == consultant).map(_ => _.salesRealizator).reduce((prev, curr) => prev + curr, 0);
        } else if (key == "executors") {
          consultantAdjustment = adjustments.filter(_ => _.executor && _.consultantId == consultant).map(_ => _.executor).reduce((prev, curr) => prev + curr, 0);
        }

        return value?.map(item => {
          if (item.pipelineProjectSumExVat) {
            return 0;
          }
          return item[key]?.filter(_ => _.consultantId == consultant).map(c => c.amount).reduce((acc, value) => acc + value, 0);
        }).reduce((acc, value) => acc + value, 0) + consultantAdjustment;
      }
      let adjustment = 0;
      if (key == "salesRealizators") {
        adjustment = adjustments.filter(_ => _.salesRealizator).map(_ => _.salesRealizator).reduce((prev, curr) => prev + curr, 0);
        return value?.map(item => item[key].map(c => c.amount).reduce((acc, value) => acc + value, 0))
          .reduce((acc, value) => acc + value, 0) + adjustment;
      } else if (key == "executors") {
        adjustment = adjustments.filter(_ => _.executor).map(_ => _.executor).reduce((prev, curr) => prev + curr, 0);
        return value?.map(item => {
          if (item.pipelineProjectSumExVat) {
            return 0;
          }
          return item[key].map(c => c.amount).reduce((acc, value) => acc + value, 0);
        }).reduce((acc, value) => acc + value, 0) + adjustment;
      }

    } else if (key == "pipelineWeightedProjectSum") {
      return value?.map(item => item["pipelineProjectSumExVat"] * (item.pipelinePercentForSuccess / 100))
        .reduce((acc, value) => acc + value, 0);
    } else if (key == "distribution") {
      if (consultant) {
        return value?.map(order => order.invoices?.map(
          i => i.distribution?.filter(_ => _.consultantId == consultant).map(t => t.amount)
            .reduce((prev, curr) => prev + curr, 0)
        ).reduce((prev, curr) => prev + curr, 0))
          .reduce((prev, curr) => prev + curr, 0);
      }
      return value?.map(order => order.invoices?.map(
        i => i.distribution?.map(t => t.amount)
          .reduce((prev, curr) => prev + curr, 0)
      ).reduce((prev, curr) => prev + curr, 0))
        .reduce((prev, curr) => prev + curr, 0);
    }

    return value?.map(item => item[key])
      .reduce((acc, value) => acc + value, 0);
  }

}
